// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eprE","rootNoMargin":"styles_rootNoMargin__1Xoe_"};